import React from "react";
import { useSelector } from "react-redux";
import Error from "../../../../components/Error/index";
import Spinner from "../../../../components/presentationals/Spinner";
import { CustomSalesCard } from "../../../../components/customSalesCard/index";
import { roundToTwo } from "../../../../utils/common/index";

const DailyActivatingOutletView = ({
  isCsvActive,
  fetchDailyActivatingOutletCsvData,
  moduleName,
  section,
}) => {
  const { dailyActivatingOutletObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    dailyActivatingOutletData: { actualCount, actualCount1 },
  } = dailyActivatingOutletObj;

  return (
    <>
      {dailyActivatingOutletObj.loading ? (
        <Spinner />
      ) : actualCount ? (
        <>
          <div className="d-block d-sm-none col-12">
            <div
              id="carousel-div"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="0"
                  className="active"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="1"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <CustomSalesCard
                    value={actualCount1}
                    tileName=" Avg DAO/Day"
                    image="Image5"
                    // csvName="daily"
                    // csvDownload={isCsvActive === "Y" ? fetchDailyActivatingOutletCsvData : ""}
                    // loading={actCsvLoading}
                    gradient="1"
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
                <div className="carousel-item">
                  <CustomSalesCard
                    value={roundToTwo(actualCount)}
                    tileName="Total DAO"
                    image="Image6"
                    csvName="daily"
                    csvDownload={
                      isCsvActive === "Y"
                        ? fetchDailyActivatingOutletCsvData
                        : ""
                    }
                    loading={actCsvLoading}
                    gradient="2"
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-sm-block col-12">
            <div className="row">
              <CustomSalesCard
                value={actualCount1}
                tileName=" Avg DAO/Day"
                image="Image5"
                // csvName="daily"
                // csvDownload={isCsvActive === "Y" ? fetchDailyActivatingOutletCsvData : ""}
                // loading={actCsvLoading}
                gradient="1"
                dashboardName={moduleName}
                viewName={section}
              />
              <CustomSalesCard
                value={roundToTwo(actualCount)}
                tileName="Total DAO"
                image="Image6"
                csvName="daily"
                csvDownload={
                  isCsvActive === "Y" ? fetchDailyActivatingOutletCsvData : ""
                }
                loading={actCsvLoading}
                gradient="2"
                dashboardName={moduleName}
                viewName={section}
              />
            </div>
          </div>
        </>
      ) : (
        <Error error={dailyActivatingOutletObj.error} />
      )}
    </>
  );
};

export default DailyActivatingOutletView;
